import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=2c238752&"
import script from "./AppTable.vue?vue&type=script&lang=js&"
export * from "./AppTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports